import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-alt': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M288 248v28c0 6.6-5.4 12-12 12h-168c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zM276 320c6.6 0 12 5.4 12 12v28c0 6.6-5.4 12-12 12h-168c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168zM384 131.9v332.1c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48h204.1c12.7 0 24.9 5.1 33.9 14.1l83.9 83.9c9 8.9 14.1 21.2 14.1 33.9zM256 51.9v76.1h76.1zM336 464v-288h-104c-13.3 0-24-10.7-24-24v-104h-160v416h288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/file-alt.js
// module id = 1730
// module chunks = 0